import AssetsIcon from "../images/AssetsIcon";
import LanguageIcon from "../images/LanguageIcon";
import LanguageActiveIcon from "../images/LanguageIconActive";
import RoleActiveIcon from "../images/RoleActiceIcon";
import RoleIcon from "../images/RoleIcon";
import TaxIcon from "../images/TaxIcon";
import TaxIconActive from "../images/TaxIconActive";
import TermsIcon from "../images/TermsIcon";
import TermsIconActive from "../images/TermsIconActive";
import CreateLanguage from "../page/Languages/CreateLanguage";
import CreateTranslation from "../page/Languages/CreateTranslation";
import Languages from "../page/Languages/Languages";
import CreateRoles from "../page/Role/CreateRoles";
import ListRole from "../page/Role/ListRole";
import PageRole from "../page/Role/PageRole";
import Roles from "../page/Role/Roles";
import CreateGroupTax from "../page/Tax/CreateGroupTax";
import CreateTax from "../page/Tax/CreateTax";
import Tax from "../page/Tax/Tax";
import TermDetail from "../page/Terms/TermDetail";
import Terms from "../page/Terms/Terms";

export const AdministraionSideBar = [
    {
        index: 4,
        name: "Tax",
        show: true,
        showRoute: true,
        path: "/tax",
        component: Tax,
        image: TaxIcon,
        imageActive: TaxIconActive
    },
    {
        index: 5,
        name: "Tax",
        show: false,
        showRoute: true,
        path: "/tax/new",
        component: CreateTax,
        image: TaxIcon,
        imageActive: TaxIconActive
    },
    {
        index: 6,
        name: "Tax",
        show: false,
        showRoute: true,
        path: "/tax/:id",
        component: CreateTax,
        image: TaxIcon,
        imageActive: TaxIconActive
    },
    {
        index: 7,
        name: "Tax",
        show: false,
        showRoute: true,
        path: "/grouptax/new",
        component: CreateGroupTax,
        image: TaxIcon,
        imageActive: TaxIconActive
    },
    {
        index: 8,
        name: "Tax",
        show: false,
        showRoute: true,
        path: "/grouptax/:id",
        component: CreateGroupTax,
        image: TaxIcon,
        imageActive: TaxIconActive
    },
    {
        index: 1,
        name: "Payment Terms",
        show: true,
        showRoute: true,
        path: "/terms",
        component: Terms,
        image: TermsIcon,
        imageActive: TermsIconActive
    },
    {
        index: 2,
        name: "Payment Terms",
        show: false,
        showRoute: true,
        path: "/terms/new",
        component: TermDetail,
        image: TermsIcon,
        imageActive: TermsIconActive
    },
    {
        index: 3,
        name: "Payment Terms",
        show: false,
        showRoute: true,
        path: "/terms/:id",
        component: TermDetail,
        image: AssetsIcon,
        imageActive: TermsIconActive
    },
    {
        index: 9,
        name: "Roles",
        show: true,
        showRoute: true,
        path: "/roles",
        component: ListRole,
        image: RoleIcon,
        imageActive: RoleActiveIcon
    },
    {
        index: 10,
        name: "Roles",
        show: false,
        showRoute: true,
        path: "/roles/new",
        component: PageRole,
        image: RoleIcon,
        imageActive: RoleActiveIcon
    },
    {
        index: 11,
        name: "Roles",
        show: false,
        showRoute: true,
        path: "/roles/:id",
        component: PageRole,
        image: RoleIcon,
        imageActive: RoleActiveIcon
    },
    {
        index: 9,
        name: "Languages",
        show: true,
        showRoute: true,
        path: "/languages",
        component: Languages,
        image: LanguageIcon,
        imageActive: LanguageActiveIcon
    },
    {
        index: 10,
        name: "Languages",
        show: false,
        showRoute: true,
        path: "/languages/new",
        component: CreateLanguage,
        image: LanguageIcon,
        imageActive: LanguageActiveIcon
    },
    {
        index: 11,
        name: "Languages",
        show: false,
        showRoute: true,
        path: "/languages/:id",
        component: CreateLanguage,
        image: LanguageIcon,
        imageActive: LanguageActiveIcon
    },
    {
        index: 12,
        name: "Languages",
        show: false,
        showRoute: true,
        path: "/translation/new",
        component: CreateTranslation,
        image: LanguageIcon,
        imageActive: LanguageActiveIcon
    },
    {
        index: 13,
        name: "Languages",
        show: false,
        showRoute: true,
        path: "/translation/:id",
        component: CreateTranslation,
        image: LanguageIcon,
        imageActive: LanguageActiveIcon
    },
]